import image1 from "../assets/image01.jpg";
import image2 from "../assets/image02.jpg";
import image3 from "../assets/image03.jpg";

export const teamData = [
  {
    image: image1,
    review:
      "Jake Founded Lectra After suffering muscular injuries as a high school and collegiate athlete. He's devoted himself to Lectra, winning the WCU-BIZ Idea competition of 335 technology companies, participated in the Collegiate Entrepreneurs Organization.",
    name: 'Jake Henry',
    status: 'Founder & CEO'
  },
  {
    image: image2,
    review: 'Nick is a recent graduate of Virginia Tech in electrical engineering and minoring in economics. He has experience in power electronics, and designing wireless charging systems for autonomous vehicles. He is leading Lectras electronics design and battery compatibility.',
    name: 'Nick Squitieri',
    status: 'Chief Technology Officer'
  },
  {
    image: image3,
    review: ' Patrick is a business management and marketing student with a minor in biology at West Chester University. He started an investment and Marketing company which he is simultaneously running with Lectra. He plans on using his marketing talents to grow Lectras audience through his marketing experience.',
    name: 'Patrick Bassil',
    status: "Chief Marketing Officer"
  }
];
